//customized icons 
import LongtailIcon from '@/assets/img/longtail.vue'
import JobtitleIcon from '@/assets/img/jobtitle.vue'
//add customized icons when necessary 
export default { 
    longtail: LongtailIcon, 
    jobtitle: JobtitleIcon
}
